import { render, staticRenderFns } from "./CareProtocolSelector.vue?vue&type=template&id=3e21ef51&"
import script from "./CareProtocolSelector.vue?vue&type=script&lang=js&"
export * from "./CareProtocolSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports